import React from 'react';
import { Row, BodyText, HeadingText } from '@paypalcorp/pp-react';
import style from './categoryTiles.less';
import * as analytics from '../../lib/analytics';

export default class extends React.Component {
  static defaultProps = {};

  state = {
    isMobile: false,
  };

  handleKeyPressCategoryTile(e, category) {
    if (e.key === 'Enter') {
      this.handleCategoryClick(category);
      window.open(`${this.props.coBrand}?category=${category}`, '_blank');
    }
  }

  handleCategoryClick = category => {
    location.href = `${this.props.coBrand}?category=${category}`;
    analytics.trackLinkWithData(
      'CategoryTile',
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      { category: category },
      'link'
    );
  };

  componentDidMount() {
    if ((/Android|webOS|iPhone|IEMobile|Opera Mini/i).test(navigator.userAgent)) {
      this.setState({
        isMobile: true,
      });
    }
  }

  renderCategoryTiles = () => {
    const maxTextLength = this.props.maxTextLength || 30;
    const categoryTiles = this.props.categories || [];
    const xlColToUse = categoryTiles.find(
      category =>
        this.props.i18n(`label.category-${category.id}`).length >
          maxTextLength
    ) ?
      'col-xl-4' :
      'col-xl-3';
    return categoryTiles.map((category, index) => {
      const categoryName = this.props.i18n(`label.category-${category.id}`);
      return (
        <div
          className={`col-xs-12 col-sm-12 col-md-6 col-lg-4 ${xlColToUse} cardCategorySelect`}
          key={index}
          tabIndex='0'
          role='link'
          onKeyDown={e => this.handleKeyPressCategoryTile(e, category.name)}
          onClick={this.handleCategoryClick.bind(this, category.name)}
        >
          <div className={'cardCategoryTiles'}>
            <div className={'cardCategoryContent'}>
              <div
                className={style.categoryTileImage}
                style={{
                  backgroundImage: `url(${category.imgURL})`,
                }}
              ></div>
              <div className={style.categoryTileName}>
                <BodyText>{categoryName}</BodyText>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  render() {
    return (
      <div id={this.props.id} className={style.charityCategories}>
        <div className={style.categoryTileRow}>
          <HeadingText as='h3' size='sm' className={'card_heading'}>
            {this.props.i18n('label.browse-categories')}
          </HeadingText>
          <Row>{this.renderCategoryTiles()}</Row>
        </div>
      </div>
    );
  }
}
